import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntil, tap, distinctUntilChanged } from 'rxjs';
import { LetDirective } from '@ngrx/component';
import { NgDestroyed } from '../../utils';
import { ActionContainerComponent } from '../floori-action-container';
import { ActionContainerDialogData } from '../../models';
import { FLOORI_DIALOG_DATA } from '../../components';
import { DragContainerDirective } from '../../directives';
import { FlooriDialogRef } from '../floori-dialog';

@Component({
    selector: 'floori-action-container-dialog',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ActionContainerComponent, LetDirective],
    templateUrl: './action-container-dialog.component.html',
    styleUrls: ['./action-container-dialog.component.scss'],
    hostDirectives: [DragContainerDirective]
})
export class ActionContainerDialogComponent extends NgDestroyed {
    private readonly data: ActionContainerDialogData =
        inject<ActionContainerDialogData>(FLOORI_DIALOG_DATA);
    private readonly dialogRef: FlooriDialogRef<ActionContainerDialogComponent> =
        inject(FlooriDialogRef);
    private readonly cdr = inject(ChangeDetectorRef);
    readonly containerData$ = this.data?.containerData$;
    readonly actionViewMap = this.data?.actionViewMap;
    readonly actionButtonMap = this.data?.actionButtonMap;

    constructor() {
        super();
        this.connectViewChange();
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    private connectViewChange(): void {
        this.containerData$
            .pipe(
                takeUntil(this.destroyed),
                distinctUntilChanged(),
                tap(() => this.cdr.markForCheck()),
            )
            .subscribe();
    }
}
